export default __webpack_public_path__ + "static/media/delivery.68a9fbba.png";